import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';

import s from './DriverEarnings.css';
import getDriverEarningsAdminQuery from './getDriverEarningsAdmin.graphql';
import Loader from '../../../components/Common/Loader/Loader';
import DriverEarningsList from '../../../components/SiteAdmin/DriverEarnings/DriverEarningsList/DriverEarningsList';
import messages from '../../../locale/messages';

class DriverEarnings extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    driverId: PropTypes.string.isRequired,
  };

  static defaultProps = {
    earningsData: {
      loading: true,
    },
  };

  render() {
    const { earningsData, earningsData: { loading }, driverId } = this.props;

    return (
      <Loader type="page" show={loading}>
        <div className={s.root}>
          <div className={s.container}>
<div className="paddingRoutesSection">
              {!loading && (
                <DriverEarningsList
                  earningsData={earningsData}
                  driverId={driverId}
                />
              )}
            </div>
          </div>
        </div>
      </Loader>
    );
  }
}

export default compose(
  withStyles(s),
  graphql(getDriverEarningsAdminQuery, {
    name: 'earningsData',
    options: (props) => ({
      variables: {
        driverId: props.driverId,
        currentPage: 1,
      },
      fetchPolicy: 'network-only',
    }),
  })
)(DriverEarnings);
